import LocalFileImporterNode from './types/local-file-importer';
import LocalFileReaderNode from './types/local-file-reader';
import LocalFileWriterNode from './types/local-file-writer';

export const localFileNodes = {
  localFileReader: LocalFileReaderNode,
  localFileWriter: LocalFileWriterNode,
  localFileImporter: LocalFileImporterNode,
};
